import React from 'react';
import { Alert, Form, Input, Button, Popconfirm } from 'antd';
import { connect } from 'react-redux';
import { useForm } from 'antd/es/form/Form';
import { FcAbout } from 'react-icons/fc';

import { IProps } from './advice.type';
import { Wrapper, Message, Link, Title } from './advice.style';
import {
  fetchTask,
  updateTask,
} from 'src/store/tasks/actions';
import useTask from './advice.use';

const AdviceComponent: React.FC<IProps> = (props) => {
  const { listId } = props;
  const { editing, onEditing, sending, handleSubmit, task } = useTask(props);

  const [form] = useForm();

  return (
    <Wrapper>
      <Title>
        <FcAbout size={20} className="me-2" />
        <h4 className="m-0">Parecer técnico</h4>
      </Title>

      {editing && task ? (
        <Alert
          className="mt-3 mb-2"
          description={
            <Form
              form={form}
              id="form-tech"
              layout="vertical"
              onFinish={handleSubmit}
              initialValues={{ technical_advice: task.technical_advice }}
            >
              <Form.Item name="technical_advice">
                <Input.TextArea
                  rows={4}
                  placeholder="Informe o parecer técnico da ordem de serviço..."
                />
              </Form.Item>

              <Popconfirm
                title="CONFIRMAR PARECER E FINALIZAR"
                description={
                  <div>
                    Deseja informar o parecer técnico e finalizar <br /> essa
                    ordem de serviço?
                  </div>
                }
                onConfirm={async () => {
                  const values = await form.validateFields();
                  await handleSubmit({ ...values, stage: 2 });
                }}
                onCancel={() => form.submit()}
              >
                <Button size="small" type="default" loading={sending}>
                  <small>SALVAR</small>
                </Button>
              </Popconfirm>
            </Form>
          }
          type="info"
        />
      ) : (
        <Alert
          className="mt-3 mb-2"
          description={
            <>
              {task?.technical_advice ? (
                <Message>{task?.technical_advice}</Message>
              ) : (
                'Não informado.'
              )}
              {listId === 1 && (
                <Link className="mt-2" onClick={onEditing}>
                  {task?.technical_advice
                    ? 'Editar parecer técnico'
                    : 'Informar parecer técnico'}
                </Link>
              )}
            </>
          }
          type="info"
        />
      )}
    </Wrapper>
  );
};

export default connect(undefined, { fetchTask, updateTask })(AdviceComponent);
